import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { UFaIconComponent, ULoadingHelper } from '@updater/angular-common';
import { UtilitiesConfig } from './utilities.config';
import { UtilitiesComponent } from './utilities-contact-providers/utilities.component';
import { UtilitiesCardComponent } from './utilities-contact-providers/utilities-card';
import { RelevantContentComponent } from '../../common/directives';

export const UtilitiesStepModule = angular
  .module('app.steps.utilities', [
    uiRouter,
    RelevantContentComponent.name,
    UFaIconComponent.name,
    ULoadingHelper.name,
  ])
  .config(UtilitiesConfig)
  .component('updUtilities', UtilitiesComponent)
  .component('updUtilitiesCard', UtilitiesCardComponent);
